<template>    
    <BaseModal
        :id="'static'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <div v-if="coincidences && coincidences.length" class="alert alert-warning mt-2 p-1" role="alert">
                    <p class="mb-1" v-if="coincidences.length > 1">There are <b>{{ coincidences.length }}</b> other inspection items with a similar name.</p>
                    <p class="mb-1" v-else>There is <b>{{ coincidences.length }}</b> inspection item with a similar name.</p>
                    <span v-for="(item, index) in coincidences" :key="index">
                        <span v-html="item.name"></span>
                        <span v-if="index < coincidences.length - 1"> - </span>
                    </span>
                </div>
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'
import _ from 'lodash'

export default {

    name:   'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "axios",
        "array_options",
        "breadcrumb",
    ],

    components: {
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data() {
        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
            room_type_table_headers: Resources.room_type_table_headers,
            coincidences: [],
            room_types: []
        }
    },

    methods: {
        debounceInput:  _.debounce(function (e)  {
            if(e)
            {
                this.findCoincidence(e)
            }
            else
            {
                this.coincidences = []
            }
        },800),

        async findCoincidence(name)
        {
            const res = await this.post(`${this.rest_api}/find_coincidences/results`, {name})
            if(res.status)
            {
                this.coincidences = res.data.coincidences
            }
            else
            {
                this.coincidences = []
                this.error_handling(res)
            }
        },
    },

    mounted() {
        
    },

    computed: {
    },

    watch: {
        async 'form_data.name' (val)
        {
            this.debounceInput(val)
        },
    }
    
}
</script>